var map = {
	"./1640s-pre-colonial-homelessness.jpg": 7074,
	"./1734-poorhouses.jpg": 7897,
	"./1830-native-removal.png": 8473,
	"./1850s-vagrancy-laws.png": 1553,
	"./1850s-vagrant-vagabond.png": 4098,
	"./1870s-tramps.png": 4091,
	"./1880s-hobo.jpg": 2311,
	"./1892-urban-slums-study.jpg": 4126,
	"./1898-tenement-housing-reform.jpg": 817,
	"./1927-river-displacement.png": 5698,
	"./1930-great-depression.jpg": 6900,
	"./1930s-public-finance-for-affordable-housing-production.jpg": 2474,
	"./1940s-federal-production-of-housing-and-urban-improvement.jpg": 861,
	"./1954-housing-act-1.jpg": 3808,
	"./1956-housing-act-2.jpg": 5837,
	"./1960s-deinstitutionalization-drives-incarceration.jpg": 3867,
	"./1962-robinson-v-california.webp": 9757,
	"./1965-housing-and-urban-renewal-act.jpg": 6918,
	"./1968-fair-housing-act.jpg": 2510,
	"./1968-powell-v-texas.jpg": 883,
	"./1970s-housed.jpg": 4925,
	"./1974-housing-and-community-development-act-of-1974.jpg": 7840,
	"./1977-federal-homeless-definition.gif": 1370,
	"./1979-callahan-v-carey.jpg": 6575,
	"./1980-social-security-amendments-act-of-1980.png": 5360,
	"./1980s-urban-shifts-and-aids.png": 1140,
	"./1984-cuts-to-social-service.jpg": 6112,
	"./1990-aids-and-homelessness.avif": 7425,
	"./1990-aids-and-homelessness.png": 3949,
	"./1990-increased-public-commitment-to-affordable-housing.jpg": 8771,
	"./1990s-literal-homelessness.jpg": 474,
	"./1990s-literal-homelessness.webp": 154,
	"./1997-interagency-council-on-homelessness.jpg": 722,
	"./1998-quantification-of-homelessness.jpg": 929,
	"./2000s-chronic-homelessness-initiative.jpg": 5669,
	"./2000s-collaborative-approaches.jpg": 0,
	"./2009-hearth-act.jpg": 7919,
	"./2010-federal-strategic-plan-to-end-homelessness.jpg": 1932,
	"./2010s-city-encampments.jpg": 520,
	"./2012-addressing-encampent.jpg": 7898,
	"./2012-addressing-encampent.png": 8638,
	"./2012-decriminalizing-homelessness.jpg": 2553,
	"./2015-bell-v-city-boise.jpg": 8846,
	"./2015-norton-v-city-of-springfield.webp": 4594,
	"./2016-guidance-on-youth-homelessness.jpg": 8644,
	"./2018-martin-v-boise.jpg": 5411,
	"./2018-martin-v-boise.webp": 3379,
	"./2018-second-strategy-to-end-homelessness.jpg": 9538,
	"./2020-anti-criminalization.jpg": 8111,
	"./2020-whole-of-government-response.avif": 7116,
	"./2021-housing-first.webp": 3312,
	"./2023-coalition-on-homelessness-v-city-and-county-of-san-francisco.jpg": 5240,
	"./2023-housing-crisis-response-act-of-2023-h-r-4233.jpg": 3839,
	"./2023-housing-is-a-human-right-act.png": 2874,
	"./2023-the-ending-homelessness-act-of-2023-h-r-4232.png": 8838,
	"./2024-byrd-v-state-of-missouri-regarding-anti-camping-laws.jpg": 4662,
	"./2024-johnson-v-grants-pass.webp": 3545,
	"./late-1980s-criminalization-of-public-space.jpg": 7707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9983;